import { Link } from "react-router-dom";
// import "../../../Utils/css/employeelist.css";
import BootstrapTable from "react-bootstrap-table-next";
import React, { useState, useEffect, useRef } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  getLeaveRequests,
  getLeaveRequestsStatus,
  rejectLeaveRequest,
  approveLeaveRequest,
  AddLeaveRequestByAdmin,
} from "../../../../services/RHService/LeaveRequestService";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import moment from "moment";
import "moment/locale/fr";
import ToolkitProvider, {
  CSVExport,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min";
/* import jsPDF from "jspdf";
 */ /* import "jspdf-autotable"; */
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";
import { getLeaveType } from "../../../../services/RHService/LeaveTypeService";
import { getAllContracts } from "../../../../services/RHService/ContractService";
import uploadAndDownloadService from "../../../../services/uploadAndDownloadFile";

const AllLeaveRequests = () => {
  //variables
  const { ExportCSVButton } = CSVExport;
  const [leaveTypeError, setLeaveTypeError] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);
  const [file, setFile] = useState(null);

  const [leaveRequests, setLeaveRequests] = useState([]);
  const [statusNumber, setStatusNumber] = useState([]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [showModify, setShowModify] = useState(false);
  const handleCloseModify = () => setShowModify(false);
  //afficher les information par defaut dans le Model
  const [fileData, setFileData] = useState(null);
  const [selectedLeaveRequest, setSelectedLeaveRequest] = useState(null);
  const [formData, setFormData] = useState({});
  const [leaveType, setLeaveType] = useState([]);
  const [contracts, setContracts] = useState([]);

  //Tout les contrats
  useEffect(() => {
    fetchContracts();
  }, []);
  const fetchContracts = () => {
    getAllContracts(getCurrentUserId())
      .then((response) => {
        setContracts(response.data?.success);
        console.log(response);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  useEffect(() => {
    getLeaveType(getCurrentUserId())
      .then((names) => {
        setLeaveType(names.success);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  useEffect(() => {
    fetchDataStatus();
    fetchData();
  }, []);
  const handleShowModify = async () => {
    setShowModify(true);
  };
  const handleInputChange = (event) => {
    const target = event.target;
    const name = target.name;
    const value = target.type === "checkbox" ? target.checked : target.value;

    if (name === "dateDeb" || name === "dateFin") {
      const startDate = new Date(name === "dateDeb" ? value : formData.dateDeb);
      const endDate = new Date(name === "dateFin" ? value : formData.dateFin);
      const timeDiff = Math.abs(endDate.getTime() - startDate.getTime());
      const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      setFormData({ ...formData, [name]: value, nbJrs: diffDays });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
  const fetchData = async () => {
    try {
      const response = await getLeaveRequests(getCurrentUserId());
      setLeaveRequests(response.data);
    } catch (error) {
      console.error("Error fetching leave requests:", error);
    }
  };

  const fetchDataStatus = async () => {
    try {
      const response = await getLeaveRequestsStatus(getCurrentUserId());
      setStatusNumber(response.data);
    } catch (error) {
      console.error("Error fetching leave request status:", error);
    }
  };

  const handleShow = async (leaveRequest) => {
    setSelectedLeaveRequest(leaveRequest);
    // if (leaveRequest && leaveRequest.fileUrl) {
    // setFileData(leaveRequest.fileUrl);
    setShow(true);
    // }
  };

  //colonnes de table
  const columns = [
    {
      dataField: "matricule",
      text: "Mat",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1;
      },
    },
    {
      dataField: "personnel",
      text: "Personnel",
      formatter: (cell, row) => `${row.firstname} ${row.lastname}`,
    },
    {
      dataField: "creationDate",
      text: "Date de demande",
      formatter: (cell) => {
        const formattedDate = moment(cell).format("YYYY-MM-DD HH:mm");
        return formattedDate;
      },
    },
    { dataField: "dateDeb", text: "Congé de" },
    { dataField: "dateFin", text: "A" },
    { dataField: "nomConge", text: "Type de congé" },
    { dataField: "nbJrs", text: "Nombre de jour" },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell, row) => {
        if (cell === "PENDING") {
          return (
            <div className="center">
              <div className="badge_leave col-blue">En attente</div>
            </div>
          );
        }

        if (cell === "APPROVED") {
          return (
            <div className="center">
              <div className="badge_leave col-green">Apprové</div>
            </div>
          );
        }
        if (cell === "REJECTED") {
          return (
            <div className="center">
              <div className="badge_leave col-red">Rejeté</div>
            </div>
          );
        } else {
          return null; // Ou vous pouvez retourner une autre représentation pour d'autres statuts
        }
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => {
        return (
          <div className="center">
            <button
              style={{
                "background-color": "white",
                "border-color": "transparent",
              }}
              onClick={() => {
                handleShow(row);
              }}
            >
              <i className="fa-solid fa-eye eye-icon"></i>
            </button>
          </div>
        );
      },
    },
  ];
  // Define the handleApprove function
  const handleApprove = async (idLeaveRequest) => {
    try {
      const userId = JSON.parse(localStorage.getItem("user")).token.idUser;
      approveLeaveRequest(idLeaveRequest, userId);
      setLeaveRequests((prevState) =>
        prevState.filter(
          (leaveRequests) => leaveRequests.idLeaveRequest !== idLeaveRequest
        )
      );
      handleClose();
      fetchDataStatus();
    } catch (error) {
      alert(error.message);
    }
  };

  const handleReject = async (idLeaveRequest) => {
    try {
      const userId = JSON.parse(localStorage.getItem("user")).token.idUser;
      rejectLeaveRequest(idLeaveRequest, userId);
      setLeaveRequests((prevState) =>
        prevState.filter(
          (leaveRequests) => leaveRequests.idLeaveRequest !== idLeaveRequest
        )
      );
      handleClose();
      fetchDataStatus();
    } catch (error) {
      alert(error.message);
    }
  };

  //pagination
  const options = {
    sizePerPage: 5,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    paginationPosition: "bottom",
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!formData.idContract || formData.idContract === "contract") {
      setLeaveTypeError("Veuillez Choisir un personnel");
    } else {
      setLeaveTypeError("");
    }

    if (!formData.idLeaveType || formData.idLeaveType === "leaveType") {
      setLeaveTypeError("Veuillez saisir un Type de congé");
    } else {
      setLeaveTypeError("");
    }
    if (!formData.dateDeb || !formData.dateFin || !formData.nbJrs) {
      toastr.error("Veuillez renseigner les champs Date début , Date Fin ");
      return;
    }
    if (new Date(formData.dateDeb) > new Date(formData.dateFin)) {
      toastr.error("La date de début doit être antérieure à la date de fin.");
      return;
    }

    formData.idAuthUser = getCurrentUserId();

    if (formData.idLeaveType && formData.idLeaveType !== "leaveType") {
      AddLeaveRequestByAdmin(formData, file)
        .then((response) => {
          if (response.status == 200)
            toastr.success("Demande envoyer avec succée.");
          handleCloseModify();
        })
        .catch((error) => {
          toastr.error("erreur dans l'envoie");
        });
    }
  };

  const onUploadFileHandler = (path) => {
    onShowFileInOtherWizndowHandler(path);
  };

  const onShowFileInOtherWizndowHandler = (path) => {
    uploadAndDownloadService
      .downloadFile(path)
      .then((response) => {
        //Build a URL from the file
        if (response.headers["content-type"] === "image/png") {
          const file = new Blob([response.data], { type: "image/png" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "application/pdf") {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpeg") {
          const file = new Blob([response.data], { type: "image/jpeg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpg") {
          const file = new Blob([response.data], { type: "image/jpg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <ToolkitProvider
        keyField="id"
        data={leaveRequests}
        columns={columns}
        exportCSV={{
          fileName: "Les_demandes_de_Congé.csv",
          onlyExportFiltered: true,
          exportAll: false,
        }}
        search
      >
        {(props) => (
          <div>
            <Modal show={showModify} onHide={handleCloseModify} size="xl">
              <Modal.Header closeButton>
                <Modal.Title>Modidier informations</Modal.Title>
              </Modal.Header>
              <Modal.Body className="show-grid">
                {/* <Form onSubmit={handleUpdate}> */}
                <Container>
                  <Row>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="card-body">
                          <div className="form-group">
                            <label>Type de Congé</label>
                            <select
                              className="custom-select form-control-border"
                              name="idLeaveType"
                              value={formData.idLeaveType}
                              onChange={handleInputChange}
                            >
                              <option value="leaveType">
                                --Choisir un Type de Congé--
                              </option>
                              {leaveType.map((l) => (
                                <option key={l.id} value={l.id}>
                                  {l.nomConge}
                                </option>
                              ))}
                            </select>
                          </div>
                          {leaveTypeError && (
                            <p style={{ color: "red" }}>{leaveTypeError}</p>
                          )}
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="card-body">
                          <div className="form-group">
                            <label>Personnels</label>
                            <select
                              className="custom-select form-control-border"
                              name="idContract"
                              value={formData.idContract}
                              onChange={handleInputChange}
                            >
                              <option value="contract">
                                --Choisir un Personnel--
                              </option>
                              {contracts.map((item) => (
                                <option
                                  key={item.idContract}
                                  value={item.idContract}
                                >
                                  {item.firstname} {item.lastname}
                                </option>
                              ))}
                            </select>
                          </div>
                          {leaveTypeError && (
                            <p style={{ color: "red" }}>{leaveTypeError}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="card-body">
                          <div className="form-group">
                            <label>Date de début de congé</label>
                            <div className="input-group date">
                              <input
                                type="date"
                                min="1900-01-01"
                                max="2100-12-31"
                                name="dateDeb"
                                value={formData.dateDeb}
                                onChange={handleInputChange}
                                className="form-control form-control-border"
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <label>Nombre de jours</label>
                            <div className="input-group">
                              <input
                                type="number"
                                disabled
                                name="nbJrs"
                                value={formData.nbJrs}
                                onChange={handleInputChange}
                                className="form-control form-control-border"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="card-body">
                          <div className="form-group">
                            <label>Date de fin de congé</label>
                            <div className="input-group date">
                              <input
                                type="date"
                                name="dateFin"
                                value={formData.dateFin}
                                onChange={handleInputChange}
                                min="2022-01-01"
                                max="2100-12-31"
                                className="form-control form-control-border "
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <label>Remarque</label>
                            <textarea
                              type="Textarea"
                              rows="2"
                              name="remarque"
                              value={formData.remarque}
                              onChange={handleInputChange}
                              cols="33"
                              className="form-control form-control-border"
                              placeholder="Description"
                            ></textarea>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6 col-lg-6">
                        <div className="card-body">
                          <div className="form-group">
                            <label
                              htmlFor="fileInput"
                              className="btn btn-dark col fileinput-button mb-2"
                            >
                              {selectedFile ? (
                                <p>{selectedFile}</p>
                              ) : (
                                <>
                                  {" "}
                                  <i className="fas fa-plus"></i>
                                  <span>Pièce justificative</span>
                                </>
                              )}
                            </label>
                            <input
                              ref={fileInputRef}
                              id="fileInput"
                              type="file"
                              style={{ display: "none" }}
                              onChange={(event) => {
                                const selectedFile = event.target.files[0];
                                setFile(selectedFile);
                                setSelectedFile(selectedFile.name);
                              }}
                              accept="image/jpeg,image/png,application/pdf"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Row>
                </Container>
                {/* </Form> */}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseModify}>
                  Fermer
                </Button>
                <Button variant="dark" onClick={handleSubmit}>
                  Confirmer
                </Button>
              </Modal.Footer>
            </Modal>
            <Modal show={show} onHide={handleClose} size="xl">
              <Modal.Header closeButton>
                <Modal.Title>Accepter ou Refusé demande</Modal.Title>
              </Modal.Header>
              <Modal.Body className="show-grid">
                <Form>
                  <Container>
                    <Row>
                      <div className="col-md-12 ">
                        <div class="card ">
                          <div className="card-header">
                            <h5>Personnel</h5>
                          </div>
                          <div class="card-body">
                            <div class="row">
                              <div className="col-md-3">
                                <strong className="center">
                                  Nom et Prenom
                                </strong>
                                <br></br>
                                {selectedLeaveRequest
                                  ? selectedLeaveRequest.firstname
                                  : ""}{" "}
                                {selectedLeaveRequest
                                  ? selectedLeaveRequest.lastname
                                  : ""}
                              </div>

                              <div className="col-md-3">
                                <strong className="center">
                                  Type de congé
                                </strong>
                                <br></br>
                                {selectedLeaveRequest
                                  ? selectedLeaveRequest.nomConge
                                  : ""}{" "}
                              </div>

                              <div className="col-md-3">
                                <strong className="center">
                                  Congé restant
                                </strong>
                                <br></br>
                                {selectedLeaveRequest
                                  ? selectedLeaveRequest.remainingDays
                                  : 0}{" "}
                                jours
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div class="card">
                          <div className="card-header">
                            <h5>Congé</h5>
                          </div>
                          <div class="card-body">
                            <div class="row">
                              <div className="col-md-3">
                                <strong className="center">Date début</strong>
                                <br></br>
                                {selectedLeaveRequest
                                  ? selectedLeaveRequest.dateDeb
                                  : ""}{" "}
                              </div>

                              <div className="col-md-3">
                                <strong className="center">Date fin</strong>
                                <br></br>
                                {selectedLeaveRequest
                                  ? selectedLeaveRequest.dateFin
                                  : ""}{" "}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="card">
                          <div className="card-header">
                            <h5>Remarque</h5>
                          </div>
                          <div className="card-body">
                            <p>
                              {selectedLeaveRequest
                                ? selectedLeaveRequest.remarque
                                : ""}
                            </p>
                          </div>
                        </div>
                      </div>
                      {selectedLeaveRequest && selectedLeaveRequest.fileUrl && (
                        <div className="col-md-12">
                          <div className="card card-dark">
                            <div className="card-header ">
                              <h5>Piéce justificative</h5>
                            </div>
                            <div
                              className="card-body"
                              onClick={(e) => {
                                onUploadFileHandler(
                                  selectedLeaveRequest.fileUrl
                                );
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              VOIR PIECE JUSTIFICATIF
                            </div>
                          </div>
                        </div>
                      )}

                      <Col xs={12} md={12} className="center">
                        {selectedLeaveRequest &&
                          selectedLeaveRequest.status === "PENDING" && (
                            <>
                              {" "}
                              <button
                                type="button"
                                className="badge_leave col-greenn mx-1"
                                onClick={() => {
                                  handleApprove(
                                    selectedLeaveRequest
                                      ? selectedLeaveRequest.idLeaveRequest
                                      : ""
                                  );
                                }}
                              >
                                Approuvé Demande
                              </button>
                              <button
                                type="button"
                                className="badge_leave col-orange mx-1"
                                onClick={() => {
                                  handleReject(
                                    selectedLeaveRequest
                                      ? selectedLeaveRequest.idLeaveRequest
                                      : ""
                                  );
                                }}
                              >
                                Refusé Demande
                              </button>
                            </>
                          )}
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  Fermer
                </Button>
              </Modal.Footer>
            </Modal>
            {/* header */}
            <div className="content-header">
              <div className="container-fluid">
                <div className="row mb-2">
                  <div className="col-sm-6">
                    <h1 className="m-0">Liste des demandes de congé</h1>
                  </div>
                  <div className="col-sm-6">
                    <ol className="breadcrumb float-sm-right">
                      <li className="breadcrumb-item">
                        <i class="fa-solid fa-house"></i>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to="/">Home</Link>
                      </li>
                      <li className="breadcrumb-item active">
                        Liste des demandes de congé
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <div className="container-fluid">
              <div className="row">
                <div class="col-12 col-sm-6 col-md-4">
                  <div class="info-box">
                    <span class="info-box-icon bg-success elevation-1">
                      <i class="fa-regular fa-calendar-check"></i>
                    </span>

                    <div class="info-box-content">
                      <span class="info-box-text">
                        Demandes traitées et approuvés
                      </span>
                      <span class="info-box-number">
                        {statusNumber
                          ? statusNumber.numberOfLeaveRequestApproved
                          : 0}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                  <div class="info-box">
                    <span class="info-box-icon bg-info elevation-1">
                      <i class="fa-solid fa-spinner"></i>
                    </span>

                    <div class="info-box-content">
                      <span class="info-box-text">Demandes en attente</span>
                      <span class="info-box-number">
                        {statusNumber
                          ? statusNumber.numberOfLeaveRequestEnAttente
                          : 0}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                  <div class="info-box">
                    <span class="info-box-icon bg-danger elevation-1">
                      <i class="fa-solid fa-xmark"></i>
                    </span>

                    <div class="info-box-content">
                      <span class="info-box-text">Demandes refusées</span>
                      <span class="info-box-number">
                        {statusNumber
                          ? statusNumber.numberOfLeaveRequestRefused
                          : 0}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="container-fluid">
              <div className="row">
                <div className="col-md-2 col-lg-2 col-sm-12  mb-2">
                  <ExportCSVButton
                    {...props.csvProps}
                    className="btn1 float-left"
                  >
                    Export CSV
                  </ExportCSVButton>
                </div>
                <div className="col-md-2 col-lg-2 col-sm-12  mb-2">
                  <Button
                    onClick={() => {
                      handleShowModify();
                    }}
                    className="btn btn-secondary"
                  >
                    Fournir une demande
                  </Button>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="card">
                    <div class="card-header">
                      <h3 class="card-title">Liste des demandes de congé</h3>
                    </div>

                    <BootstrapTable
                      {...props.baseProps}
                      data={leaveRequests}
                      columns={columns}
                      pagination={paginationFactory(options)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </ToolkitProvider>
    </div>
  );
};

export default AllLeaveRequests;
